import { P } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Partner } from 'src/app/shared/models/partner';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-approve-pros-modal',
  templateUrl: './approve-pros-modal.component.html',
  styleUrls: ['./approve-pros-modal.component.scss']
})
export class ApproveProsModalComponent implements OnInit {

  partner: Partner;

  //test data
  pros = [
    {
      id: 20,
      selected: false,
      type: 'Source Audio',
      year: 2023,
      quarter: 'Q1'
    },
    {
      id: 21,
      selected: false,
      type: 'ASCAP',
      year: 2023,
      quarter: 'Q1'
    },
    {
      id: 22,
      selected: false,
      type: 'BMI',
      year: 2023,
      quarter: 'Q1'
    }
  ]

  constructor(private userService: UserService, private partnerService: PartnerService, private snackbarService: SnackBarService, public dialogRef: MatDialogRef<ApproveProsModalComponent>) { }

  ngOnInit() {

    //track selected partner
    this.partnerService.selectedPartner$.subscribe((x) => {
      this.partner = x;
    })
  }

  getPartnerPros() {

    this.pros = [];
    
    this.partnerService.getPartnerProsByPartnerId(this.partner.id).subscribe(
      (resProDetails) => {
        resProDetails.forEach(details => {
          
        })
      },
      (error) => {
        //handle error
      })
  }

  approvePros() {
    //TEST CODE - WILL REPLACE WITH ACTUAL PROS PULLED FROM DB AS SOON
    //AS I DETERMINE HOW TO ASSOCIATE PARTNER PROS WITH PARTNERS

    let partnerProIds = [];

    //extract ids from selected pros for payload
    this.pros.forEach(pro => {
      if(pro.selected){
        partnerProIds.push(pro.id);
      }
    });

    this.partnerService.approvePartnerPros(partnerProIds).subscribe(
      (resPros) => {
      //update pro list

      this.snackbarService.showSnackBarMessage("PRO(s) Approved!", "Close");

      this.onClose();
    },
  (error) => {
    //handle error

    this.snackbarService.showSnackBarMessage("An error occured. Approval of PRO(s) may not have been successful.", "Close", undefined, true);
  });
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
